import { Fragment, useState } from "react";
import { H5, P, ToolTip } from "../../../../../AbstractElements";
import { Href, TooltipsModal } from "../../../../../Constants/Constants";
import { TooltipData } from "../../../../../Data/UiKits/Modal";

const TooltipLink = () => {
  const [tooltips, setTooltips] = useState<{ [key: string]: boolean }>({});

  const toggleTooltip = (id: string) => {
    setTooltips((prevTooltips) => ({
      ...prevTooltips,
      [id]: !prevTooltips[id],
    }));
  };
  return (
    <Fragment>
      <H5>{TooltipsModal}</H5>
      <P className="mt-2">
        {TooltipData.map(({ id, content, text }) => (
          <Fragment key={id}>
            <a className="tooltip-test txt-primary" href={Href} id={id}>{content}</a>
            {text}
            <ToolTip autohide={true} isOpen={tooltips[id] || false} target={id} toggle={() => toggleTooltip(id)}>
              {"Tooltip"}
            </ToolTip>
          </Fragment>
        ))}
      </P>
    </Fragment>
  );
};
export default TooltipLink;
